import { t } from './index';
import { updateMyMemorialButtonLabels } from '../features/go-to-my-memorial';
import { getCurrentUser } from '../auth/session';
import { updateGardenProfilePill, updateAccountCard } from '../features/auth-flow';
import { updateOnboardingCopy } from '../features/onboarding';

export function updateSeoMeta(): void {
  document.title = t('seo.title');

  const setMeta = (selector: string, content: string) => {
    const el = document.querySelector(selector) as HTMLMetaElement | null;
    if (el) el.content = content;
  };

  const desc = t('seo.description');
  setMeta('meta[name="description"]', desc);
  setMeta('meta[property="og:title"]', t('seo.title'));
  setMeta('meta[property="og:description"]', desc);
  setMeta('meta[name="twitter:title"]', t('seo.title'));
  setMeta('meta[name="twitter:description"]', desc);
}

export function updateStaticDom(): void {
  updateSeoMeta();

  const templeImg = document.querySelector('.temple-image');
  if (templeImg) templeImg.setAttribute('alt', t('seo.templeAlt'));

  const homeBtn = document.getElementById('home-btn');
  if (homeBtn) homeBtn.title = t('toolbar.home');

  const findBtn = document.getElementById('find-empty-btn');
  if (findBtn) {
    findBtn.title = t('toolbar.findEmpty');
    findBtn.setAttribute('aria-label', t('toolbar.findEmpty'));
  }

  const myMemorialBtn = document.getElementById('my-memorial-btn');
  if (myMemorialBtn && !myMemorialBtn.hasAttribute('hidden')) {
    updateMyMemorialButtonLabels();
  } else if (myMemorialBtn) {
    myMemorialBtn.title = t('toolbar.myMemorial');
    myMemorialBtn.setAttribute('aria-label', t('toolbar.myMemorial'));
  }

  const accountBtn = document.getElementById('account-btn');
  if (accountBtn) {
    updateAccountCard(getCurrentUser());
  }

  updateGardenProfilePill(getCurrentUser());
  updateOnboardingCopy();
}
